import moment from "moment";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import CalendarIndex from "./Calendar";
import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import { endLoading, initLoading } from "../../store/slices/generics.slice";
import scheduleIcon from "../../assets/images/icons/icon_schedule_header.svg";
import { getLingoPlans, handleCalendarInitialParams } from "../../store/middleware";

function Calendar() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);
  const { activeScreen } = useSelector((state) => state.calendarReducer);

  const atualDate = moment();

  const loadInfos = async () => {
    await dispatch(initLoading());
    await dispatch(handleCalendarInitialParams("list", atualDate, atualDate, true));
    await dispatch(getLingoPlans(null));
    await dispatch(endLoading());
  };

  useEffect(() => {
    loadInfos();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view new-view calendar-view">
      <SideMenu />
      <section>
        <Header title={t("ITEM_SCHEDULE")} icon={scheduleIcon} t={t} />
        {activeScreen !== "list" && (
          <div className="legendaSchedule">
            <p className="noShow">{t("CLASS_SUB_NOSHOW")}</p>
            <p className="canceled">{t("CLASS_SUB_CANCELED")}</p>
            <p className="confirmed">{t("CLASS_SUB_CONFIRMED")}</p>
            <p className="done">{t("CLASS_SUB_DONE")}</p>
            <p className="pending">{t("CLASS_SUB_PENDING")}</p>
            <p className="outoflimit">{t("CANCELLED_OUT_lIMIT")}</p>
          </div>
        )}
        {user?.role && <CalendarIndex />}
      </section>
    </div>
  );
}

export default Calendar;
